import { useApiMutation } from "app/modules/api-client";
import type { GaTriggerContainerProps } from "app/modules/ga-connect";
import { GaTriggerContainer } from "app/modules/ga-connect";

import { useInvalidateRelatedGaMappingQueries } from "./hooks";

export type GATriggerWithPropertyMappingSchema = Omit<GaTriggerContainerProps, "onPropertySelected"> & {
    activationId: string;
    hasGaMapping?: boolean;
};

export const GATriggerWithPropertyMapping = ({
    activationId,
    hasGaMapping,
    onClose,
    ...other
}: GATriggerWithPropertyMappingSchema) => {
    const { mutateAsync } = useApiMutation(
        "Activation",
        hasGaMapping ? "activationGaMappingUpdate" : "activationGaMappingCreate",
    );
    const invalidateRelatedGaMappingQueries = useInvalidateRelatedGaMappingQueries(activationId);

    const onPropertySelected: GaTriggerContainerProps["onPropertySelected"] = async ({
        connectionId,
        propertyId,
        streamId,
    }) => {
        await mutateAsync([
            activationId,
            {
                connectionId,
                isActive: true,
                propertyId,
                streamId,
            },
        ]);
    };

    const handleClose = () => {
        void invalidateRelatedGaMappingQueries();

        onClose?.();
    };

    return (
        <GaTriggerContainer
            {...other}
            onClose={handleClose}
            onPropertySelected={onPropertySelected}
        />
    );
};